import SidebarFullVersion from './SidebarFullVersion';

export default SidebarFullVersion;
